var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 16.003V-.003l13.148 8.19H4.11l8.602 7.816H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M11.475 7.715L.48.86v14.663h10.995l-8.61-7.808h8.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M4.59 11.21l-.683-.323.368-.667-.743.15-.097-.757-.518.555-.517-.555-.09.757-.743-.15.36.667-.682.323.682.322-.36.66.743-.142.09.75.517-.555.518.555.097-.75.743.143-.368-.66.683-.323zm-.45-6.225l-.503-.232.27-.48-.54.097-.075-.54-.375.398-.375-.398-.067.54-.54-.097.262.48-.495.232 1.215.24 1.223-.24zM4.38 5a1.462 1.462 0 11-2.925 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNepal);
export default __webpack_public_path__ + "static/media/Nepal.2f70e3cef85d803658d75fa190c85786.svg";
export { ForwardRef as ReactComponent };